import { usePage } from '@inertiajs/react'
import type { CurrentPerson, SharedProps } from '@/types'

/** 当前选中的成员（含我对其的访问权限）。 */
export function useCurrentPerson(): CurrentPerson | null {
  return usePage<SharedProps>().props.current_person
}

/** 我对当前成员是否可写（owner / write）。读权限或无成员时为 false。 */
export function useCanWrite(): boolean {
  return useCurrentPerson()?.can_write ?? false
}
